/**
 * 请求方法类
 * @description 当前使用axios进行数据获取，接口返回格式需要统一规范
 */
 import axios from 'axios'

 export default axios
 